export const colors = {
  light: '#F7FAFC',
  dark: '#171923',
  blue: '#4299E1',
};
